<template>
	<el-main class="mainbox shipwrap">
		<div class="flexBetween">
			<div class="card-header">
				<div>
					<div class="card-title">我的书单</div>
					<div class="card-desc">管理个人书单，方便收藏与查阅</div>
				</div>
			<el-button size="mini" type="primary" @click="addInfo">新建书单</el-button>
		</div>

		<div v-loading="loading" class="shipbox" element-loading-text="加载中...">
			<el-row v-if="list.length" :gutter="12">
				<el-col v-for="item in list" :key="item.id" :span="8">
					<el-card class="box-card" shadow="hover">
						<div style="text-align: center; position: relative">
							<img alt="" src="../../assets/images/booklist/files.svg" style="width: 170px" />
							<div class="mobile-box">
								<el-tag size="medium" type="warning">{{ formatterListType(item.listType) }}</el-tag>
							</div>
						</div>
						<div class="book-title">
							<span> {{ item.listName }}</span>
						</div>
						<div class="address-box">
							{{ item.listDesc }}
						</div>
						<div class="button-box">
							<el-button type="text" @click="modifyInfo(item)">修改</el-button>
							<el-button type="text" @click="removeInfo(item.id)">删除</el-button>
						</div>
					</el-card>
				</el-col>
			</el-row>
			<div v-if="list.length === 0">
				<el-empty description="暂无书单"></el-empty>
			</div>
		</div>
		<!--    新增书单-->
		<DialogBookList
			ref="DialogBookListRef"
			:dialogTitle="dialogTitle"
			:dialogVisible="dialogVisible"
			:form="form"
			:rules="rules"
			@addConfirmInfo="addConfirmInfo"
			@cancel="dialogVisible = false"
			@modifyConfirmInfo="modifyConfirmInfo"
		/>
		</div>
	</el-main>
</template>

<script>
import Y from '@/utils/Y';
import { getMemberGetBookList, deleteMemberRemoveBookList, postMemberUpdateBookList, postMemberAddBookList } from '@/api/book/type.js';
import mtils from 'mtils';
import DialogBookList from '@/views/Book/components/DialogBookList.vue';
export default {
	data() {
		return {
			list: [],
			bodystyle: { padding: '0px' },

			loading: false,

			dialogTitle: '新增书单',
			dialogVisible: false,
			form: {
				listType: null,
				listName: '',
				listDesc: '',
				coverImage: ''
			},
			rules: {
				listType: [
					{
						required: true,
						message: '书单类型不可为空',
						trigger: 'change'
					}
				],

				listName: [
					{
						required: true,
						message: '书单名称不可为空',
						trigger: 'blur'
					}
				],

				listDesc: [
					{
						trigger: 'blur'
					}
				],

				coverImage: []
			}
		};
	},
	components: {
		DialogBookList
	},
	created() {
		this.getMemberGetBookList();
	},
	methods: {
		formatterListType(value) {
			let listType = '';
			switch (value) {
				case 1:
					listType = '推荐书单';
					break;
				case 2:
					listType = '阅读计划';
					break;
				case 3:
					listType = '收藏夹';
					break;
				case 4:
					listType = '专题书单';
					break;
				case 5:
					listType = '自定义';
					break;
			}
			return listType;
		},

		//获取书单列表
		async getMemberGetBookList() {
			this.loading = true;
			const res = await getMemberGetBookList();
			this.list = res.data.rows;
			this.loading = false;
		},

		//确认添加书单
		addConfirmInfo(val) {
			postMemberAddBookList(val)
				.then(res => {
					Y.msg.success('书单保存成功！');
					this.dialogVisible = false;
					this.getMemberGetBookList();
				})
				.catch(err => {
					Y.msg.error(err.message);
				});
		},

		//确认修改书单
		modifyConfirmInfo(val) {
			postMemberUpdateBookList(val)
				.then(res => {
					Y.msg.success('书单修改成功！');
					this.dialogVisible = false;
					this.getMemberGetBookList();
				})
				.catch(err => {
					Y.msg.error(err.message);
				});
		},

		// 添加书单
		addInfo() {
			this.form = {};
			this.dialogTitle = '新增书单';
			this.dialogVisible = true;
		},

		// 编辑书单
		modifyInfo(item) {
			this.form = { ...item };
			this.dialogTitle = '修改书单';
			this.dialogVisible = true;
		},

		// 删除书单
		removeInfo(id) {
			Y.confirm('确认删除此书单吗？').then(rlt => {
				if (rlt.confirm) {
					deleteMemberRemoveBookList(id)
						.then(res => {
							Y.msg.success('书单删除成功！');
							this.getMemberGetBookList();
						})
						.catch(err => {
							Y.msg.error(err.message);
						});
				}
			});
		},

		setDefault(sid) {
			Y.confirm('确认修改默认书单吗？').then(rlt => {
				if (rlt.confirm) {
					Y.msg.success('恭喜！修改成功');
				}
			});
		}
	}
};
</script>

<style lang="less" scoped>
.shipwrap {
	margin-left: 20px;
	background-color: #fff;
	padding: 20px;
	border-radius: 10px;
	h3 {
		margin: 0 0 20px;
		font-weight: 400;
		font-size: 24px;
		color: #333;
	}
}
.shipbox {
	margin: 20px -9px 0;
}
.box-card {
	min-height: 190px;
	margin: 15px 9px;
}
.el-card {
	border: 1px solid #e2e8f0;
	color: #475569;
	font-size: 14px;
	line-height: 1.6;
}
/deep/ .el-card__header {
	padding: 20px 20px 0;
	color: #334155;
	font-size: 18px;
	border-bottom: none;
}
/deep/ .el-card__body {
	padding: 15px 20px;
}
.actbox {
	flex-direction: column;
	cursor: pointer;
	min-height: 190px;
}
.actbox .iconbox {
	font-size: 34px;
	color: #94a3b8;
}
.actbox:hover {
	color: #155dfc;
}
.actbox:hover .iconbox {
	color: #155dfc;
}
.button-box {
	text-align: right;
	//display: none;
}
//.box-card:hover .button-box {
//	display: block;
//}
//.el-button--text {
//	color: #ec2b2d;
//	padding: 15px 0 0;
//}

.mobile-box {
	margin-bottom: 8px;
	position: absolute;
	top: -15px;
	left: -21px;
}
.book-title {
	font-size: 18px;
	color: #333;
	margin-bottom: 8px;
}

.address-box {
	display: -webkit-box;
	-webkit-line-clamp: 3;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
	height: 68px;
}
//媒体查询-pad
@media screen and (min-device-width: 768px) and (max-device-width: 1023px) {
	.el-col-8 {
		width: 100%;
	}
}
@media screen and (min-device-width: 1024px) and (max-device-width: 1366px) {
	.el-col-8 {
		width: 49.8%;
	}
}

	.card-header {
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
		margin-bottom: 24px;
		padding-bottom: 20px;
		border-bottom: 1px dashed #e2e8f0;
	}
	.card-title {
		font-size: 18px;
		font-weight: 700;
		color: #0f172a;
		margin-bottom: 4px;
	}
	.card-desc {
		font-size: 13px;
		color: #94a3b8;
		line-height: 1.6;
	}
</style>
